import React from 'react';
import styles from './TimeLeft.module.scss';
import Section from '../../../desktopAdStructure/components/sections/components/section';
import {getHoursAndMinutes} from 'data/utils/calculators';
import Interval from 'react-interval-rerender';

export interface ISectionProps {
  timeRemaining: number;
  loading?: boolean;
}

const time = (timeRemaining: number) => {
  const now = new Date().getTime();
  if (timeRemaining - now > 0) {
    return getHoursAndMinutes(now, timeRemaining);
  }
  return (<span style={{textDecoration: "line-through"}}>0d 0h 0m</span>);
}

const TimeLeft = ({loading, ...props}: ISectionProps) => {
  return (
    <Section width={150} className={`${styles.TimeLeft} ${loading ? styles.loading : ''}`.trim()} loading={loading}>
      <Interval delay={1000 * 60}>
        {() => time(props.timeRemaining)}
      </Interval>
    </Section>
  );
};

TimeLeft.defaultProps = {
  timeRemaining: 0,
};
export default TimeLeft;
